import { Tooltip } from '@medeloop/medeloop-components-library';

type TooltipButtonProps = {
  tooltipText: string;
  onClick: (event?: React.MouseEvent<HTMLDivElement>) => void;
  side?: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactNode;
};

export const TooltipButton = ({
  tooltipText,
  onClick,
  side = 'bottom',
  children,
}: TooltipButtonProps) => {
  const handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation(); // Prevent the click event from bubbling up to the parent element
    onClick(e);
  };

  return (
    <Tooltip delayDuration={100}>
      <Tooltip.Trigger>
        <div
          className="text-gray-300 cursor-pointer hover:text-white px-2 py-2 rounded-md"
          onClick={handleClick}
        >
          {children}
        </div>
      </Tooltip.Trigger>
      <Tooltip.Portal>
        <Tooltip.Content side={side}>
          <p>{tooltipText}</p>
          <Tooltip.Arrow />
        </Tooltip.Content>
      </Tooltip.Portal>
    </Tooltip>
  );
};
